import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-838c1966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Nav__Left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-left" })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-left" })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "Nav__Right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-right" })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 22 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-right" })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({'Nav': true, 'dark': _ctx.themeForceDark, 'is-hidden': this.hidden, 'at-start': _ctx.rotation < _ctx.gap/2, 'at-end': _ctx.rotation > _ctx.max - _ctx.gap/2})
  }, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            tabindex: "-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goLeft()))
          }, _hoisted_4)
        ])
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            tabindex: "-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goRight()))
          }, _hoisted_8)
        ])
      ])
    ])
  ], 2))
}